// extracted by mini-css-extract-plugin
export default {"orderSummary":"orderSummary_orderSummary__wPuq2","label":"orderSummary_label__FK47y"};